const calculateNumberOfNights = (startDate, endDate) => {
  if (!startDate || !endDate) return 0;
  const start = new Date(startDate);
  const end = new Date(endDate);
  const differenceInTime = end - start;
  return Math.ceil(differenceInTime / (1000 * 3600 * 24)); // Convert milliseconds to days
};

export default calculateNumberOfNights;
